import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, DefaultFailureAction, DefaultSuccessAction } from "../common/reducers/utilities";

const roleLevels = {
    administrator: 'global',
    auditor: 'global',
    'EPCR manager': 'global',
    'EPCR auditor': 'global',
    'EPCR reviewer': 'global',
    'enrollment manager': 'global',
    'equipment manager': 'office',
    'equipment auditor': 'office',
    'document uploader': 'office',
    'meeting manager': 'office',
    'meeting auditor': 'office',
    'ticket manager': 'office',
    'ticket auditor': 'office'
}

const userSlice = createSlice({
    name: 'users',
    initialState: {
        data: [],
        userRoles: []
    },
    reducers: {
        set: (state, action) => {
            state.data = action.payload;
        },
        setUserRoles: (state, action) => {
            const roles = [...action.payload];
            //roles.sort();
            state.userRoles = roles;
        },
        addOrUpdate: (state, action) => {
            const user = action.payload;
            const idx = state.data.findIndex(u => u.username == user.username);
            if (idx >= 0) {
                state.data.splice(idx, 1, user);
            } else {
                state.data.push(user);
            }
        },
        remove: (state, action) => {
            state.data = state.data.filter(user => user.username !== action.payload.username);
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => userSlice.getInitialState())
    }
});

// #region network operations
const visualizeSuccess = (verb, action) => DefaultSuccessAction(verb, 'user', action);
const visualizeFailure = verb => DefaultFailureAction(verb, 'user');

const fetchAllUsers = network => network.get('/api/v1/users', userSlice.actions.set, visualizeFailure('get'));
const fetchUserRoles = network => network.get('/api/v1/roles', userSlice.actions.setUserRoles, visualizeFailure('get'));

export const createUser = (network, user) => network.post('/api/v1/createUser', user, userSlice.actions.addOrUpdate, visualizeFailure('create'))
export const updateUser = (network, delta) => network.put('/api/v1/user', delta, userSlice.actions.addOrUpdate, visualizeFailure('update'))
export const updateUserRoles = (network, username, roles) => network.put('/api/v1/roles/' + encodeURIComponent(username), roles, userSlice.actions.addOrUpdate, visualizeFailure('get'));
export const removeUser = (network, user) => network.delete('/api/v1/deleteUser/' + user.username, userSlice.actions.remove, visualizeFailure('remove'))
export const resetPassword = (network, username, password) => network.post('/api/v1/resetUserPassword', {username, password});
export const changePassword = (network, currentPassword, newPassword) => network.post('/api/v1/changePassword', { currentPassword, newPassword });
// #endregion

// #region selectors
const selectUsers = state => state.users.data;
const selectUserRoles = state => state.users.userRoles;
// #endregion

const listen = {}

export const canRouteUser = ({credentials}) => credentials.hasRole(['administrator', 'auditor']);

export const [useUsers] = dataHookFactory(selectUsers, { run: fetchAllUsers, immortal: true, listen });
export const [useRoles] = dataHookFactory(selectUserRoles, { run: fetchUserRoles, immortal: true, listen });
export const useRoleLeves = () => roleLevels;

const reducer = { name: userSlice.name, reducer: userSlice.reducer };
export default reducer;